import { Icon } from "./primitives"

export const DEFAULT_SUBPROCESSOR_ICON = "link"

export default function SubprocessorIcon({ item, size = 20 }) {
    if (item?.logoUrl) {
        return (
            <img
                src={item.logoUrl}
                alt=""
                className="sp-icon__img"
                style={{ width: size, height: size }}
            />
        )
    }
    return <Icon name={item?.icon || DEFAULT_SUBPROCESSOR_ICON} size={size} />
}
